import React from "react";
import _ from "lodash";
import Button from "Components/button/Button";
import Input from "Components/input/Input";
import WarningBanner from "Components/warningBanner/WarningBanner";
import MultipleSelector from "Components/multipleSelector/MultipleSelector";
import TranslatedString from "Components/TranslatedString";
import t from "Utils/translation";

import cx from "classnames";
import s from "./limitsManagers.scss";

export default class LimitsForm extends React.Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.state = {
      viewFields: [
        "domain_codes",
        "max_domains",
        "max_email_accounts",
        "max_email_accounts_archive",
        "max_email_accounts_25gb",
        "max_email_accounts_50gb",
        "max_email_accounts_100gb",
      ],
    };
  }

  componentWillUnmount() {
    this.props.resetFields(...this.state.viewFields);
  }

  submit(e) {
    e.preventDefault();
    this.props.submitForm(this.props.formData, this.state.viewFields);
  }

  clearDomainsSelect(values) {
    this.props.setFormFieldValue({ ...values, domain_codes: [] });
  }

  render() {
    const {
      className,
      setFormFieldValue,
      formErrors,
      areDomainsWithoutManagersLoading,
      manager,
      domainsWithoutManagers,
      isFormLoading,
      formData,
      loggedUser,
    } = this.props;

    return (
      <form className={s.general} method="post" onSubmit={this.submit}>
        <div className={s.wrapInfoBtn}>
          <div className={s.warnignMsg}>
            {!this.props.areFieldsPristine(...this.state.viewFields) && !formErrors.onForm && (
              <WarningBanner color="yellow-text" msg={t("infoMsg.unsaveChanged")} />
            )}

            {formErrors.onForm && <WarningBanner msg={formErrors.onForm} color="red" />}
          </div>

          <div className={s.infoBtnGroup}>
            <Button docsKey="managers_settings" color="docs" type="button">
              button.docs
            </Button>
            <Button type="submit" loading={isFormLoading}>
              button.save
            </Button>
          </div>
        </div>

        <div className={s.settings}>
          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.managerLimits.title")}</div>
              <div className="sectionDesc">{t("settings.sections.managerLimits.desc")}</div>
            </div>
            <div className="formsSectionSP">
              <Input
                name="max_domains"
                type="number"
                onChange={setFormFieldValue}
                errors={formErrors.max_domains}
                value={formData.max_domains}
                label={<TranslatedString>input.label.maxDomainsAvailable</TranslatedString>}
                min={-1}
                max={99999}
                step="1"
                required
              />

              <Input
                name="max_email_accounts"
                type="number"
                onChange={setFormFieldValue}
                errors={formErrors.max_email_accounts}
                value={formData.max_email_accounts}
                label={<TranslatedString>input.label.maxAccountsAvailable8</TranslatedString>}
                min={-1}
                max={99999}
                step="1"
                required
              />

              <Input
                name="max_email_accounts_25gb"
                type="number"
                onChange={setFormFieldValue}
                errors={formErrors.max_email_accounts_25gb}
                value={formData.max_email_accounts_25gb}
                label={<TranslatedString>input.label.maxAccountsAvailable25</TranslatedString>}
                min={-1}
                max={formData.max_email_accounts !== -1 ? formData.max_email_accounts : 9999999}
                step="1"
                required
              />

              <Input
                name="max_email_accounts_50gb"
                type="number"
                onChange={setFormFieldValue}
                errors={formErrors.max_email_accounts_50gb}
                value={formData.max_email_accounts_50gb}
                label={<TranslatedString>input.label.maxAccountsAvailable50</TranslatedString>}
                min={-1}
                max={formData.max_email_accounts !== -1 ? formData.max_email_accounts : 9999999}
                step="1"
                required
              />

              <Input
                name="max_email_accounts_100gb"
                type="number"
                onChange={setFormFieldValue}
                errors={formErrors.max_email_accounts_100gb}
                value={formData.max_email_accounts_100gb}
                label={<TranslatedString>input.label.maxAccountsAvailable100</TranslatedString>}
                min={-1}
                max={formData.max_email_accounts !== -1 ? formData.max_email_accounts : 9999999}
                step="1"
                required
              />

              <Input
                className="inputAddMargin"
                name="max_email_accounts_archive"
                type="number"
                onChange={setFormFieldValue}
                errors={formErrors.max_email_accounts_archive}
                value={formData.max_email_accounts_archive}
                label={<TranslatedString>input.label.maxArchiveAvailable</TranslatedString>}
                min={-1}
                max={formData.max_email_accounts !== -1 ? formData.max_email_accounts : 9999999}
                step="1"
                required
              />

              {!areDomainsWithoutManagersLoading && (
                <MultipleSelector
                  className="inputFull2"
                  name="domain_codes"
                  label={<TranslatedString>input.label.domainsManager</TranslatedString>}
                  options={_.map(domainsWithoutManagers, (v) => ({
                    value: v.code,
                    label: v.name,
                  }))}
                  firstPanelTitle={<TranslatedString>input.label.domainsAvailable</TranslatedString>}
                  secondPanelTitle={<TranslatedString>input.label.domainsSelected</TranslatedString>}
                  onChange={setFormFieldValue}
                  selected={_.map(manager.selected_domain_data, (v) => ({
                    value: v.code,
                    label: v.name,
                  }))}
                />
              )}
            </div>
          </div>
        </div>
      </form>
    );
  }
}
